import {
    useMemo,
    useCallback,
} from 'react'
import AddIcon from '@mui/icons-material/Add'
import Typography from '@mui/material/Typography'

import useLabel from 'app/hooks/useLabel'
import RichTable from 'app/shared-components/RichTableReduxWrapper'
import useRequestTable from 'app/hooks/useRequestTable'
import Card from 'app/shared-components/Card'
import {
    RequestKeys,
} from 'app/hooks/useRequest'
import useLoadFilters from 'app/Apps/DomainObject/hooks/useLoadFilters'

import useAccountManagementRoutes from 'app/SkyNetRoutes/hooks/useAccountManagementRoutes'
import requests from 'app/requests/Opportunity.requests'
import useGetOpportunityById from '../hooks/useGetOpportunityById'

import useStyles from './Lanes.styles'
import columns from './Lanes.columns'

type Props = {
    id: number,
}

const UniqueTableKey = 'Account.Opportunities.Lanes'

const Lanes = ({
    id,
}: Props) => {
    const {
        Lanes: LanesRoutes,
    } = useAccountManagementRoutes()
    const {
        classes,
    } = useStyles()
    const l = useLabel()
    const {
        data,
    } = useGetOpportunityById(id)

    const {
        onParamsChange,
        loadData: load,
    } = useRequestTable<Props>({
        key: RequestKeys.getLanesFromOpportunity,
        params: {
            id,
        },
        config: requests.filterLanesRequest,
        enabled: Boolean(id),
    })

    const injectLoadFilters = useLoadFilters(
        requests.filterCountLanesRequest({
            id,
        }),
    )

    const columnsWithFilters = useMemo(() => {
        return injectLoadFilters(columns({
            l,
        }))
    }, [
        injectLoadFilters,
        l,
    ])

    const handleAddLane = useCallback(() => {
        LanesRoutes.Create.navigate({
            options: {
                state: {
                    autofill: {
                        opportunity: {
                            id: data?.id,
                        },
                    },
                },
            },
        })
    }, [
        LanesRoutes,
        data?.id,
    ])

    const onRowClick = useCallback(({
        id: idLane,
    }: { id: number }) => {
        LanesRoutes.Overview.navigate({
            params: {
                key: idLane,
            },
            options: {
                state: {
                    filter: {
                        accountId: [data?.account?.id],
                    },
                },
            },
        })
    }, [
        LanesRoutes.Overview,
        data?.account?.id,
    ])

    return (
        <Card
            fullHeight
            contentClass={classes.cardContent}
        >
            <div className={classes.header}>
                <Typography variant="h3">
                    Lanes
                </Typography>
                <div className={classes.icon}>
                    <AddIcon
                        className={classes.icon}
                        onMouseDown={handleAddLane}
                    />
                </div>
            </div>
            <div
                className={classes.gridCardWrapper}
            >
                <RichTable
                    configName={UniqueTableKey}
                    onParamsChange={onParamsChange}
                    name={UniqueTableKey}
                    load={load}
                    columns={columnsWithFilters}
                    uniqField="id"
                    className={classes.tableContent}
                    classNames={{
                        contentWrapper: classes.tableContentWrapper,
                    }}
                    onRowClick={onRowClick}
                />
            </div>
        </Card>
    )
}

export default Lanes
